import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { required } from '@mhub/web-validations';
import {
  Button,
  Container,
  Dimmer,
  Form,
  Icon,
  Label,
  Loader,
  Popup,
  Table,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import AppForm from '../components/AppForm';
import SelectBank from '../components/AppForm/SelectBank';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { flashMessage } from '../actions/flash';

class BankAccounts extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    project: PropTypes.shape({
      name: PropTypes.string,
    }),
    loading: PropTypes.bool,
    onDefaultAdd: PropTypes.func.isRequired,
    onDefaultSave: PropTypes.func.isRequired,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultBankAccount = {
    selectedBank: null,
    newBank: '',
    newAccountNumber: '',
    isEditing: false,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    const state = this.getPropsToState(props);
    this.validationForEdit = {};
    this.validationForCreate = {
      newBank: createRef(),
      newAccountNumber: createRef(),
    };
    this.state = {
      dataToBeDelete: {},
      isEditing: false,
      isNew: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = this.getPropsToState(nextProps);
    this.setState({
      ...state,
    });
  }
  getPropsToState = (props) => {
    const data = props.data;
    const loading = props.loading;

    return {
      data,
      loading,
      ...BankAccounts.defaultBankAccount,
    };
  }
  handleEditChange = (index, event, { value, name }) => {
    event.preventDefault();
    const extraState = {};
    if (name === 'isEdit') {
      // toggle isEditing flag to allow only one edit at a time
      extraState.isEditing = !this.state.isEditing;
    }

    const { data } = this.state;
    data[index] = Object.assign({}, data[index], { [name]: value });
    this.setState({
      data,
      ...extraState,
    });
  }
  handleInputChange = (e, d) => {
    this.setState({
      [d.name]: d.value,
    });
  }
  handleSelectChange = (e, d) => {
    this.setState({
      newBank: d.value,
      selectedBank: d.value,
    });
  }
  handleSubmit = (e) => {
    e.preventDefault();
  }
  onClickAdd = (e) => {
    e.preventDefault();
    this.setState({ isNew: true });
  }
  onCancelCreate = (e) => {
    e.preventDefault();
    this.setState({
      isNew: false,
    });
  }
  onCreate = (e) => {
    e.preventDefault();
    return AppForm.validate(this.validationForCreate, this.state)
      .then((validations) => {
        const value = {
          bank: this.state.newBank,
          accountNumber: this.state.newAccountNumber,
          isActive: true,
        };
        this.props.onDefaultAdd(validations, { value });
      });
  }
  onSave = (index, e, { name, value }) => {
    e.preventDefault();
    const { store } = this.context;
    const { project, t } = this.props;
    const bankAccount = this.state.data[index];

    if (name === 'isActive' && !value) {
      if (project.marketplaceIsPublish || project.marketplaceBuyerIsPublish) {
        return store.dispatch(flashMessage({
          header: t('Error', { ns: TRANSLATION_FILES.translation }),
          message: t('At least an active bank account is required to launch project to Marketplace', { ns: TRANSLATION_FILES.translation }),
          icon: 'warning sign',
          type: 'error',
        }));
      }
    }

    bankAccount[name] = value;
    const data = {
      bank: bankAccount.bank,
      accountNumber: bankAccount.accountNumber,
      id: bankAccount.id,
      isActive: bankAccount.isActive,
      index,
    };

    return AppForm.validate(this.validationForEdit, data)
      .then((validations) => {
        this.props.onDefaultSave(validations, { value: data });
      });
  }
  render() {
    const { auth, t } = this.props;
    return (
      <Container>
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={this.state.loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        <AppForm
          onSubmit={this.handleSubmit}
          ref={(ref) => { this.form = ref; }}
          as="div"
        >
          <Table
            striped
            selectable
            padded
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell colSpan={4} textAlign="left">
                  <Button
                    disabled={this.state.isNew}
                    primary
                    size="small"
                    icon="add"
                    content={t('Add', { ns: TRANSLATION_FILES.translation })}
                    onClick={this.onClickAdd}
                  />
                </Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell>{t('Bank')}</Table.HeaderCell>
                <Table.HeaderCell>{t('Account Number')}</Table.HeaderCell>
                <Table.HeaderCell />
                <Table.HeaderCell />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                this.state.data.length > 0 ?
                  this.state.data.map((value, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>
                        {value.bank}
                      </Table.Cell>
                      <Table.Cell>
                        {value.accountNumber}
                      </Table.Cell>
                      <Table.Cell textAlign="right">
                        { value.isActive ? (
                          <Label color="blue" basic horizontal>
                            {t('Active', { ns: TRANSLATION_FILES.constants })}
                          </Label>
                        ) : (
                          <Label color="grey" basic horizontal>
                            {t('Inactive', { ns: TRANSLATION_FILES.constants })}
                          </Label>
                        )}
                      </Table.Cell>
                      <Table.Cell>
                        {
                          <Popup
                            trigger={
                              <Button
                                negative={value.isActive}
                                positive={!value.isActive}
                                name="isActive"
                                className="ui compact icon primary button"
                                onClick={
                                e => this.onSave(index, e, { name: 'isActive', value: !value.isActive })
                              }
                              >
                                {
                                  value.isActive ? <Icon name="close" /> :
                                  <Icon name="check" />
                                }
                              </Button>
                          } content={t(value.isActive ? 'Deactivate' : 'Activate')}
                          />
                        }
                      </Table.Cell>
                    </Table.Row>
                  ))
                :
                  <Table.Row>
                    <Table.Cell colSpan={4} textAlign="center">
                      {
                        this.state.loading ?
                        <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                        : `${t('No bank account found')}.`
                      }
                    </Table.Cell>
                  </Table.Row>
              }
            </Table.Body>
            {
              this.state.isNew ? (
                <Table.Body>
                  <Table.Row active>
                    <Table.Cell>
                      <SelectBank
                        country={auth && auth.company ? auth.company.countryCode : ''}
                        validation={[required]}
                        validateLabel={t('Bank')}
                        ref={this.validationForCreate.newBank}
                        onChange={this.handleSelectChange}
                        text={this.state.selectedBank ? null : t('Select {{title}}', { title: t('Bank') })}
                        autoComplete="off"
                        name="selectedBank"
                        value={this.state.selectedBank}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      <AppForm.Input
                        hideMessage
                        validateLabel={t('Account Number')}
                        name="newAccountNumber"
                        value={this.state.newAccountNumber}
                        onChange={this.handleInputChange}
                        ref={this.validationForCreate.newAccountNumber}
                        validation={[required]}
                        type="text"
                      />
                    </Table.Cell>
                    <Table.Cell />
                    <Table.Cell collapsing>
                      <Popup
                        trigger={
                          <Button
                            positive
                            className="ui compact icon primary button"
                            onClick={this.onCreate}
                          >
                            <Icon name="plus" />
                          </Button>
                        } content={t('Create', { ns: TRANSLATION_FILES.translation })}
                      />
                      <Popup
                        trigger={
                          <Button
                            negative
                            className="ui compact icon primary button"
                            onClick={this.onCancelCreate}
                          >
                            <Icon name="close" />
                          </Button>
                        } content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                      />
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              ) : null
            }
          </Table>
        </AppForm>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(BankAccounts.mapStateToProps)(BankAccounts));



// WEBPACK FOOTER //
// ./src/components/BankAccounts.jsx